export const DishType = Object.freeze({
  BASE: "BASE",
  PROTEIN: "PROTEIN",
  SAUCE: "SAUCE",
  REGULAR: "REGULAR",
});
